export default function isPlainObject(value) {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  var prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}